import * as React from 'react';
import { compose, withHandlers, withState } from 'recompose';
import Download from 'material-ui/svg-icons/content/save';
import { Loader } from '@components/loader';

const enhance = compose(
  withState('itemClicked', 'setItemClicked', false),
  withState('loader', 'setLoader', false),
  withHandlers({
    handleClick: ({
      itemClicked,
      setLoader,
      setItemClicked,
      eventId,
      row: { id },
      saveAudioRecordNotify,
      pbx
    }) => async () => {
      if (itemClicked) {
        return;
      }
      setLoader(true);
      const responseOk = await saveAudioRecordNotify(pbx, eventId, id);

      if (responseOk) {
        setItemClicked(true);
      }
      setLoader(false);
    }
  })
);

const View: any = ({ loader, itemClicked, handleClick }) => (
  <div style={{ width: '100%' }} onClick={handleClick}>
    {loader && <Loader />}
    {itemClicked ? 'Přidáno do souborů v žádosti' : <Download />}
  </div>
);
export const EventsAudioRecordDownload: any = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsAudioRecordDownload.tsx